import request from '../helpers/request';

export const changeRequestControlDate = ({ requestId, value }) => {
  return request.put(
    `/Request/set_alert_date`,
    {
      requestId,
      alertDate: value,
    },
    'При изменении даты контроля произошла ошибка',
    'Error'
  );
};
